var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Text, View } from 'react-native';
import ActivityHistoryLink from '@/components/ActivityHistoryLink';
import { UpvoteTargetTypeDto } from '@/generated-sources/openapi';
import useAppComponents from '@/hooks/useAppComponents';
import useNavigation from '@/navigation/useNavigation';
import { useQueries } from '@tanstack/react-query';
export default function HistorySection() {
    var _a, _b, _c, _d;
    const { api } = useAppComponents();
    const navigation = useNavigation();
    const [placeReview, toiletReview] = useQueries({
        queries: [
            {
                queryKey: ['ReviewHistory', 'Review', UpvoteTargetTypeDto.PlaceReview],
                queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.listRegisteredPlaceReviewsPost({ limit: 1 })).data; }),
            },
            {
                queryKey: ['ReviewHistory', 'Review', UpvoteTargetTypeDto.ToiletReview],
                queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.listRegisteredToiletReviewsPost({ limit: 1 })).data; }),
            },
        ],
    }).map(r => r.data);
    const [placeUpvote, toiletUpvote] = useQueries({
        queries: [
            {
                queryKey: ['ReviewHistory', 'Upvote', UpvoteTargetTypeDto.PlaceReview],
                queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.listUpvotedPlaceReviewsPost({ limit: 1 })).data; }),
            },
            {
                queryKey: ['ReviewHistory', 'Upvote', UpvoteTargetTypeDto.ToiletReview],
                queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.listUpvotedToiletReviewsPost({ limit: 1 })).data; }),
            },
        ],
    }).map(r => r.data);
    const totalNumberOfReviews = ((_a = placeReview === null || placeReview === void 0 ? void 0 : placeReview.totalNumberOfItems) !== null && _a !== void 0 ? _a : 0) +
        ((_b = toiletReview === null || toiletReview === void 0 ? void 0 : toiletReview.totalNumberOfItems) !== null && _b !== void 0 ? _b : 0);
    const totalNumberOfUpvote = ((_c = placeUpvote === null || placeUpvote === void 0 ? void 0 : placeUpvote.totalNumberOfUpvotes) !== null && _c !== void 0 ? _c : 0) +
        ((_d = toiletUpvote === null || toiletUpvote === void 0 ? void 0 : toiletUpvote.totalNumberOfUpvotes) !== null && _d !== void 0 ? _d : 0);
    return (_jsxs(View, { className: "pt-3 px-5", children: [_jsx(Text, { className: "py-5 text-[18px] leading-[29px] font-pretendard-bold text-black", children: "\uB9AC\uBDF0 \uD788\uC2A4\uD1A0\uB9AC" }), _jsx(View, { className: "h-[1px] bg-gray-20" }), _jsx(ActivityHistoryLink, { elementName: "review_link", onPress: () => navigation.navigate('Review/History'), title: "\uB0B4\uAC00 \uC791\uC131\uD55C \uB9AC\uBDF0", count: totalNumberOfReviews }), _jsx(ActivityHistoryLink, { elementName: "review_upvote_link", onPress: () => navigation.navigate('Review/Upvote'), title: "\uB3C4\uC6C0\uC774 \uB3FC\uC694", count: totalNumberOfUpvote })] }));
}
